"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ADDON_RESOURCES_DOCS_DOMAIN_MAP = void 0;
var enum_1 = require("./enum");
exports.ADDON_RESOURCES_DOCS_DOMAIN_MAP = (_a = {},
    _a[enum_1.AddonResourcesHostType.DEFAULT] = enum_1.DocsOriginType.DEFAULT,
    _a[enum_1.AddonResourcesHostType.ENTERPRISE_WECOM] = enum_1.DocsOriginType.ENTERPRISE_WECOM,
    _a);
//# sourceMappingURL=constant.js.map